import React from 'react';

function TermsOfUse() {
    return (
        <div>
            <section className="terms-of-use">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="block-text center" style={{ marginTop: 150 }}>
                                <h3 className="heading" style={{ color: "#119f24", marginBottom: 30 }}>
                                    Terms of Use
                                </h3>
                            </div>
                        </div>

                        <div className="col-md-12" style={{ marginBottom: 100 }}>
                            <div className="terms-of-use-content" style={{ color: "#ccc", fontSize: "16px", lineHeight: "1.8", textAlign: "left" }}>
                                
                                <h5 style={{marginTop: 20}}>1. Introduction</h5>
                                <p>
                                    Welcome to <strong>OSCAR Token</strong> (“OSCAR,” “we,” “our,” or “us”). These Terms of Use ("Terms") govern your access to and use of the OSCAR Token ecosystem, including but not limited to 
                                    our website, smart contracts, staking mechanisms, and any other related services (collectively, the "Services").
                                </p>
                                <p>
                                    By using OSCAR Token on the **Moonshot launchpad on the Base Network**, you **agree to these Terms**. If you **do not agree**, you must immediately stop using any of our Services.
                                </p>

                                <h5 style={{marginTop: 20}}>2. Eligibility</h5>
                                <p>To access and use our Services, you must:</p>
                                <ul>
                                    <li>Be at least **18 years old** or of legal age in your jurisdiction.</li>
                                    <li>Not be located in any jurisdiction subject to **sanctions or restrictions**.</li>
                                    <li>Not engage in any **fraudulent, illegal, or prohibited** activities.</li>
                                    <li>Ensure compliance with **all applicable laws** regarding cryptocurrency usage.</li>
                                </ul>

                                <h5 style={{marginTop: 20}}>3. Decentralized Nature</h5>
                                <p>OSCAR operates as a **fully decentralized** token, meaning:</p>
                                <ul>
                                    <li>No central authority controls the token’s **supply, transactions, or governance**.</li>
                                    <li>All transactions are executed via **smart contracts on the Base blockchain**.</li>
                                    <li>We **do not store user funds** or provide custody services.</li>
                                    <li>Users are fully responsible for managing their **wallets, private keys, and security**.</li>
                                </ul>

                                <h5 style={{marginTop: 20}}>4. Use of Services</h5>
                                <p>You agree to use OSCAR’s services for **lawful and intended** purposes only.</p>
                                <h4>Prohibited Activities Include:</h4>
                                <ul>
                                    <li>Engaging in **market manipulation** (e.g., pump and dump, wash trading).</li>
                                    <li>Using OSCAR Token for **fraudulent or illicit** activities.</li>
                                    <li>Interfering with **smart contracts** or attempting **hacks**.</li>
                                    <li>Bypassing security measures or **abusing referral programs**.</li>
                                </ul>

                                <h5 style={{marginTop: 20}}>5. Risks and Disclaimers</h5>
                                <p>By using OSCAR, you acknowledge the **high-risk** nature of cryptocurrencies, including:</p>
                                <ul>
                                    <li><strong>Volatility:</strong> Token prices fluctuate heavily.</li>
                                    <li><strong>Smart Contract Risks:</strong> Potential **bugs, exploits, or vulnerabilities**.</li>
                                    <li><strong>Regulatory Risks:</strong> Government regulations may impact OSCAR.</li>
                                    <li><strong>Loss of Funds:</strong> Transactions **cannot be reversed** once executed.</li>
                                </ul>

                                <h5 style={{marginTop: 20}}>6. Wallets and Security</h5>
                                <p>OSCAR does not store private keys or wallet credentials. You are responsible for:</p>
                                <ul>
                                    <li>Using a **secure, non-custodial** wallet (e.g., MetaMask, Phantom).</li>
                                    <li>Backing up your **seed phrase** securely.</li>
                                    <li>Protecting against **phishing attacks and scams**.</li>
                                </ul>

                                <h5 style={{marginTop: 20}}>7. Token Utility and Transactions</h5>
                                <p>OSCAR Token can be used for:</p>
                                <ul>
                                    <li>**Staking**: Earn rewards by locking OSCAR tokens.</li>
                                    <li>**Trading**: Buy/sell OSCAR on decentralized exchanges.</li>
                                    <li>**Community Governance**: Participate in DAO proposals.</li>
                                </ul>
                                <p>All transactions are <strong>final and irreversible</strong>. Ensure transaction details are correct before signing.</p>

                                <h5 style={{marginTop: 20}}>8. Fees and Costs</h5>
                                <p>Users may incur fees including:</p>
                                <ul>
                                    <li><strong>Gas Fees:</strong> Paid to miners/validators for blockchain transactions.</li>
                                    <li><strong>Staking Fees:</strong> Percentage deducted when staking rewards are claimed.</li>
                                    <li><strong>DEX Trading Fees:</strong> Applied by decentralized exchanges (not controlled by OSCAR).</li>
                                </ul>

                                <h5 style={{marginTop: 20}}>9. Third-Party Integrations</h5>
                                <p>OSCAR may integrate with third-party platforms (e.g., DexScreener, Moonshot Launchpad). We are **not responsible** for:</p>
                                <ul>
                                    <li>Third-party **data security breaches**.</li>
                                    <li>External **wallet provider issues**.</li>
                                    <li>Platform **outages or failures**.</li>
                                </ul>

                                <h5 style={{marginTop: 20}}>10. Intellectual Property</h5>
                                <p>All OSCAR content, logos, and branding materials are **intellectual property** of OSCAR. Users **cannot**:</p>
                                <ul>
                                    <li>Copy or redistribute our **branding, trademarks, or website content**.</li>
                                    <li>Claim **false partnerships or endorsements**.</li>
                                    <li>Use OSCAR materials for **fraudulent projects**.</li>
                                </ul>

                                <h5 style={{marginTop: 20}}>11. Regulatory Compliance</h5>
                                <p>OSCAR operates in a **decentralized manner** and is not registered with any financial authorities. However, users are responsible for:</p>
                                <ul>
                                    <li>Complying with **local laws and tax regulations**.</li>
                                    <li>Ensuring cryptocurrency **legality in their jurisdiction**.</li>
                                </ul>

                                <h5 style={{marginTop: 20}}>12. Limitation of Liability</h5>
                                <p>To the fullest extent permitted by law, OSCAR is **not liable** for:</p>
                                <ul>
                                    <li>Loss of **funds due to wallet mismanagement**.</li>
                                    <li>**Smart contract errors, exploits, or hacks**.</li>
                                    <li>Regulatory **restrictions, freezes, or bans**.</li>
                                </ul>

                                <h5 style={{marginTop: 20}}>13. Indemnification</h5>
                                <p>You agree to indemnify and hold harmless **OSCAR, its team, and affiliates** against any claims arising from:</p>
                                <ul>
                                    <li>Your use or misuse of the **OSCAR Token**.</li>
                                    <li>Violations of **these Terms**.</li>
                                    <li>Actions that cause **financial losses to other users**.</li>
                                </ul>

                                <h5 style={{marginTop: 20}}>14. Amendments and Updates</h5>
                                <p>These Terms may be updated periodically. We will provide updates via:</p>
                                <ul>
                                    <li>Official website announcements.</li>
                                    <li>Community channels (Discord, Telegram).</li>
                                </ul>

                                <h5 style={{marginTop: 20}}>15. Contact Information</h5>
                                <p>If you have questions regarding these Terms, contact us:</p>
                                <ul>
                                    <li><strong>Official Website: </strong><a href={"https://www.oscar.meme"} target='_blank'>https://www.oscar.meme</a></li>
                                    <li><strong>Community Support: </strong><a href={"https://discord.com/invite/5TEYunU7zg"} target='_blank'>Discord</a></li>  
                                </ul>

                                <hr style={{ borderTop: "1px solid #444", margin: "20px 0" }} />

                                <p><strong>Final Notice:</strong> By using OSCAR, you acknowledge the risks, agree to these Terms, and confirm full responsibility for your actions.</p>

                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default TermsOfUse;
